import { join } from 'juriquery'

import { Query } from '../types'

/** @deprecated use LOGGING_ROOT_ROUTE */
export const LOGGING_LEGACY_ROOT_ROUTE = '/surgicallogs'
export const LOGGING_ROOT_ROUTE = '/logging'

export const getReplacedLoggingRoute = (splat: string, query?: Query) =>
  join(`${LOGGING_ROOT_ROUTE}/${splat}`, query)

export const LOGGING_LOGS_ROUTE = `${LOGGING_ROOT_ROUTE}/clinics/:clinicId/logs`
export const LOGGING_LOGS_CREATE_ROUTE = `create`
export const LOGGING_LOGS_CREATE_GENERATE_OVERVIEW_ROUTE = `create/generate/overview`
export const LOGGING_LOG_ROUTE = `:id`
export const LOGGING_LOG_EDIT_ROUTE = `:id/edit`
export const LOGGING_LOG_EXPORT_ROUTE = `:id/export`
export const LOGGING_LOG_PRINT_FORM_ROUTE = `:id/print-form`
export const LOGGING_LOG_ENTRY_EDIT_ROUTE = `:id/entries/:entryId/edit`
export const LOGGING_LOG_ENTRY_SHOW_ROUTE = `:id/entries/:entryId/show`

const getRouteWithInjectedId = (route: string, id: number) =>
  route.replace(':id', `${id}`)

export const getLoggingLogsRoute = (clinicId: number) =>
  LOGGING_LOGS_ROUTE.replace(':clinicId', `${clinicId}`)

export const getLoggingLogsCreateRoute = (clinicId: number, query?: Query) =>
  join(`${getLoggingLogsRoute(clinicId)}/${LOGGING_LOGS_CREATE_ROUTE}`, query)

export const getLoggingLogsCreateGenerateOverviewRoute = (
  clinicId: number,
  query?: Query,
) =>
  join(
    `${getLoggingLogsRoute(
      clinicId,
    )}/${LOGGING_LOGS_CREATE_GENERATE_OVERVIEW_ROUTE}`,
    query,
  )

export const getLoggingLogRoute = (
  clinicId: number,
  logId: number,
  query?: Query | null,
) =>
  join(
    `${getLoggingLogsRoute(clinicId)}/${getRouteWithInjectedId(
      LOGGING_LOG_ROUTE,
      logId,
    )}`,
    query ?? undefined,
  )

export const getLoggingLogEditRoute = (
  clinicId: number,
  logId: number,
  query?: Query,
) =>
  join(
    `${getLoggingLogsRoute(clinicId)}/${getRouteWithInjectedId(
      LOGGING_LOG_EDIT_ROUTE,
      logId,
    )}`,
    query,
  )

export const getLoggingLogPrintFormRoute = (
  clinicId: number,
  logId: number,
  query?: Query,
) =>
  join(
    `${getLoggingLogsRoute(clinicId)}/${getRouteWithInjectedId(
      LOGGING_LOG_PRINT_FORM_ROUTE,
      logId,
    )}`,
    query,
  )

export const getLoggingLogExportRoute = (
  clinicId: number,
  logId: number,
  query?: Query,
) =>
  join(
    `${getLoggingLogsRoute(clinicId)}/${getRouteWithInjectedId(
      LOGGING_LOG_EXPORT_ROUTE,
      logId,
    )}`,
    query,
  )

const getRouteWithInjectedEntryId = (
  route: string,
  id: number,
  entryId: number,
) => getRouteWithInjectedId(route, id).replace(':entryId', `${entryId}`)

export const getLoggingLogEntryEditRoute = (
  clinicId: number,
  logId: number,
  entryId: number,
  query?: { date: string } & Query,
) =>
  join(
    `${getLoggingLogsRoute(clinicId)}/${getRouteWithInjectedEntryId(
      LOGGING_LOG_ENTRY_EDIT_ROUTE,
      logId,
      entryId,
    )}`,
    query,
  )

export const getLoggingLogEntryShowRoute = (
  clinicId: number,
  logId: number,
  entryId: number,
  dueDate?: string,
) =>
  join(
    `${getLoggingLogsRoute(clinicId)}/${getRouteWithInjectedEntryId(
      LOGGING_LOG_ENTRY_SHOW_ROUTE,
      logId,
      entryId,
    )}`,
    {
      date: dueDate,
    },
  )
